import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="fade-in" data-testid="about-page">
      <section className="relative h-[60vh] w-full overflow-hidden">
        <img src="https://images.pexels.com/photos/13722886/pexels-photo-13722886.jpeg" alt="The Teak Studio atelier" className="w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(11,11,12,0.85), rgba(11,11,12,0.2))" }} />
        <div className="absolute inset-0 max-w-[1440px] mx-auto px-6 md:px-16 flex flex-col justify-end pb-16">
          <div className="font-micro text-[#B8895C] mb-4">About The Studio</div>
          <h1 className="font-serif text-[#EDE4D3] text-5xl md:text-7xl leading-[1.05] max-w-3xl">A quieter kind of luxury.</h1>
        </div>
      </section>

      <section className="max-w-[1000px] mx-auto px-6 md:px-12 py-24">
        <div className="grid md:grid-cols-[1fr_2fr] gap-16">
          <div className="font-micro text-[#8A8680] md:sticky md:top-32 md:self-start">Our Origin</div>
          <div className="space-y-6 text-[#D8D6D1] leading-relaxed">
            <p className="text-lg">
              The Teak Studio was born inside our family workshop &mdash; three generations of woodwork, one very stubborn belief:
              luxury furniture should not cost three times what it did to make.
            </p>
            <p>
              We&apos;re a small atelier in Pitampura, Delhi, working directly with karigars whose grandfathers built the same joints
              our fathers were taught to check. Every piece is made to order. Every dimension is yours to specify. Every fabric
              and finish is sampled before you commit.
            </p>
            <p>
              What you see on this site is not curated stock. It is a starting point &mdash; a shape, a scale, a language &mdash;
              that we then finish in the wood, fabric and dimension that fits your room.
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 md:px-12 py-16 grid md:grid-cols-3 gap-8">
        {[
          {t: "Direct from Factory", d: "No showrooms. No middlemen. Every rupee goes into materials or craft."},
          {t: "Made to Order", d: "4&ndash;6 weeks. Every dimension yours. Nothing sits in a warehouse."},
          {t: "Sampled Before You Commit", d: "Order our ₹299 fabric &amp; wood swatches. Feel it in your hand first."},
        ].map((c, i) => (
          <div key={i} className="p-10" style={{ background: "#141414", border: "1px solid var(--hairline)" }}>
            <div className="font-micro text-[#B8895C] mb-4">0{i + 1}</div>
            <div className="font-serif text-[#EDE4D3] text-2xl mb-3" dangerouslySetInnerHTML={{__html: c.t}} />
            <div className="text-[#8A8680] leading-relaxed" dangerouslySetInnerHTML={{__html: c.d}} />
          </div>
        ))}
      </section>

      <section className="max-w-[1000px] mx-auto px-6 md:px-12 py-24">
        <div className="grid md:grid-cols-[1fr_2fr] gap-16">
          <div className="font-micro text-[#8A8680] md:sticky md:top-32 md:self-start">Reach Us</div>
          <div className="space-y-4 text-[#D8D6D1]">
            <div className="flex justify-between py-4" style={{ borderBottom: "1px solid var(--hairline)" }}>
              <span className="font-micro text-[#8A8680]">Studio</span>
              <span>Pitampura, Delhi &mdash; India</span>
            </div>
            <div className="flex justify-between py-4" style={{ borderBottom: "1px solid var(--hairline)" }}>
              <span className="font-micro text-[#8A8680]">WhatsApp</span>
              <a className="link-underline" href="https://wa.me/917982295008" target="_blank" rel="noreferrer">+91 79822 95008</a>
            </div>
            <div className="flex justify-between py-4" style={{ borderBottom: "1px solid var(--hairline)" }}>
              <span className="font-micro text-[#8A8680]">Email</span>
              <span className="break-all">Info.theteakstudio@gmail.com</span>
            </div>
            <div className="flex justify-between py-4" style={{ borderBottom: "1px solid var(--hairline)" }}>
              <span className="font-micro text-[#8A8680]">Instagram</span>
              <a className="link-underline" href="https://www.instagram.com/theteakstudio_/" target="_blank" rel="noreferrer">@theteakstudio_</a>
            </div>
            <div className="pt-6 flex gap-4">
              <Link to="/custom-design" className="btn-bronze" data-testid="about-cta-commission">Start a Commission</Link>
              <Link to="/category/swatches" className="btn-ghost" data-testid="about-cta-swatches">Order Swatches</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
